import e from "./server-component.mjs";
import { createRichTextHook as o } from "../core/richtext-hoc.mjs";
const i = o(e, {
  isServerContext: !0
});
export {
  i as useStoryblokServerRichText
};
